import { SkeletonComponent } from '@design-system';
import React from 'react';

export const FormationListPageSkeleton: React.FC = () => {
    return (
        <>
            {[...Array(6)].map((_, index) => (
                <SkeletonComponent
                    key={index}
                    count={1}
                    style={{
                        height: '70px',
                        width: '100%',
                        margin: '5px 0',
                        borderRadius: '12px'
                    }}
                />
            ))}
        </>
    );
};
